export enum NewsType {
    Table = 1,
    ImageAndText,
    Vetrina,
    Popup
}
